/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { addOriginToUrl, addParamsToQuery, deepCopy, HttpMethods, TransportRequestTypes } from '../../../../core';
import { clearBaseRequestFieldsFromData } from '../../../../helpers/request-helpers';

import type {
    NextFunction,
    TransportMiddlewareContext,
    TransportMiddlewareRequest,
    TransportMiddlewareResponse,
} from '../../../../core';

export const processUrlMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { config } = ctx;
    const { originalUrl, originalData, options } = req;
    const { requestInit, type, skipBaseUrl } = options;
    const isRest = type === TransportRequestTypes.ToRestServer || type === TransportRequestTypes.ToStreamUploadFileRest;
    const baseUrlPrefix = skipBaseUrl ? '' : config.getBaseUrl();
    const urlPrefix = isRest ? config.getRestPrefix() : baseUrlPrefix;
    const preparedUrl: string = addOriginToUrl(`${urlPrefix}${originalUrl}`);
    const isRestGetRequest = isRest && requestInit.method === HttpMethods.Get;

    req.url = isRestGetRequest
        ? addParamsToQuery(preparedUrl, clearBaseRequestFieldsFromData(deepCopy(originalData) as Record<string, any>))
        : preparedUrl;

    next();
};
